export default __webpack_public_path__ + "images/b1f32c421fb83cd2b71d797b596eb475.svg";